/**
 * Deduplicação em memória: type + payload + bucket de 1s.
 */

import type { SendEventParams } from '../utils/sendEvent';

const DEDUPE_TTL_MS = 2000;
const recent = new Map<string, number>();

function canonicalPayload(data: SendEventParams['eventData']): string {
  try {
    return JSON.stringify(data);
  } catch {
    return String(Date.now());
  }
}

function dedupeKey(type: SendEventParams['type'], data: SendEventParams['eventData']): string {
  const bucket = Math.floor(Date.now() / 1000);
  return `${type}:${canonicalPayload(data)}:${bucket}`;
}

export function shouldDedupeEvent(
  type: SendEventParams['type'],
  data: SendEventParams['eventData']
): boolean {
  const now = Date.now();
  for (const [k, ts] of recent) {
    if (now - ts > DEDUPE_TTL_MS) recent.delete(k);
  }
  const key = dedupeKey(type, data);
  if (recent.has(key)) return true;
  recent.set(key, now);
  return false;
}

export function _testClearDedupe(): void {
  recent.clear();
}
